import API from './base';
import { SLOTS_API_URLS } from '../constants';

class BookingsAPI extends API {
  list(examCenterName, siteId, dateMin, dateMax, timezone) {
    return this.get(SLOTS_API_URLS[examCenterName], {
      exam_center_id: siteId,
      from_date: dateMin,
      to_date: dateMax,
      company_name: examCenterName,
      timezone_name: timezone,
    });
  }

  book(payload) {
    return this.post('/api/web/v1/reservations', payload);
  }
}

export default new BookingsAPI();
